import FilesIllustraionIcon from "@icons/FilesIllustrationIcon";
import { DEVICE, useWindowSizeChanged } from "@hooks/DeviceSize";
import { StyledBox, StyledTypography } from "./styles";

const NoDataAvailable = () => {
  const device = useWindowSizeChanged();
  const isDesktop = device === DEVICE.DESKTOP;

  return (
    <StyledBox isDesktop={isDesktop}>
      <StyledTypography> No data available</StyledTypography>
      <FilesIllustraionIcon />
    </StyledBox>
  );
};

export default NoDataAvailable;
